import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { ModelID } from '@/types';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { TaskSearchParams, featureKeys, featurePath } from '.';
import { Task } from '@/types';

type QueryFnType = typeof findTask;

type UseTaskOptions = {
  id: ModelID;
  search?: TaskSearchParams;
  config?: QueryConfig<QueryFnType>;
};

const findTask = (id: ModelID, search: any = {}) => get<Task>(`${featurePath}/${id}`, search);

export const useTask = ({ id, search = {}, config = {} }: UseTaskOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: featureKeys.detail(+id),
    queryFn: () => findTask(id, search),
  });
};
